<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'
import ProductOfferList from '@components/product-offer-list.vue'
import { productMethods } from '@state/helpers'
import PurchaseDialog from '@components/purchase-dialog.vue'

export default {
  page: {
    title: 'View Product',
    meta: [{ name: 'description', content: 'The View Product page.' }],
  },
  components: { Layout, ProductOfferList, PurchaseDialog },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isWorking: false,
      dialog: false,
      displayProduct: this.product,
    }
  },
  mounted() {
    analyticsService.trackPageView('View Product')
  },
  methods: {
    ...productMethods,
    subscribeUnsubscribe() {
      this.isWorking = true
      if (this.product.isSubscribed) {
        this.unsubscribeToProduct({ productId: this.product.id })
          .then(() => {
            this.displayProduct.isSubscribed = false
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      } else {
        this.subscribeToProduct({ productId: this.product.id })
          .then(() => {
            this.displayProduct.isSubscribed = true
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              if (
                err.response.data.message.toLowerCase().indexOf('drops') !== -1
              ) {
                this.dialog = true
                return
              }

              if (err.response.data.message) {
                this.$swal
                  .fire({
                    title: 'Error!',
                    text: err.response.data.message,
                    icon: 'error',
                    confirmButtonText: 'Go to Settings',
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      this.$router.push({ name: 'profile' })
                    }
                  })

                return
              }

              this.error = err.response.data.message
            }
          })
          .finally(() => {
            this.isWorking = false
          })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <h3>{{ product.name }}</h3>
    <label :class="$style.subTitle"
      >Availability statuses are delayed by several minutes.</label
    >
    <div :class="$style.subUnsub">
      <BaseButton
        v-if="!displayProduct.isSubscribed"
        :disabled="isWorking"
        @click.stop="subscribeUnsubscribe"
      >
        <BaseIcon v-if="isWorking" name="sync" spin />
        <span v-else>
          Subscribe to Product
        </span>
      </BaseButton>

      <BaseButton
        v-if="displayProduct.isSubscribed"
        :disabled="isWorking"
        @click.stop="subscribeUnsubscribe"
      >
        <BaseIcon v-if="isWorking" name="sync" spin />
        <span v-else>
          Unsubscribe from Product
        </span>
      </BaseButton>
    </div>

    <v-container grid-list-md>
      <div v-if="product.links.length === 0">
        <p>This product has no active listings</p>
      </div>
      <ProductOfferList :links="product.links"></ProductOfferList>
    </v-container>

    <v-dialog v-model="dialog" max-width="600px">
      <PurchaseDialog title="Need more Drops?"></PurchaseDialog>
    </v-dialog>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.subTitle {
  font-size: 10px;
  color: gray;
}

.subUnsub {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
